import {booking} from './feature.booking.svelte.js';
import {booker} from '../booker/feature.booker.svelte.js';
import {BUYABLE_TYPE_NON_PACKAGEDEAL, BUYABLE_TYPE_PACKAGEDEAL, ENTRY_DURATION_DAY, ENTRY_DURATION_EVENING, ENTRY_TYPE_OVERRULE_BADENKAART, ENTRY_TYPE_OVERRULE_BADENKAART_KORT, PAYMENT_TYPE_IDEAL, PRESELECTION_TYPE_ACTION_ENTRY, PRESELECTION_TYPE_ACTION_PACKAGE_DEAL, PRESELECTION_TYPE_ENTRY, PRESELECTION_TYPE_PACKAGE_DEAL, PRESELECTION_TYPE_TREATMENT, PRESELECTION_TYPE_TREATMENT_SUBCAT} from '../../AppConstants';
import * as products_select from '../products/products.scenarios.select.svelte.js';
import * as packagedeals_select from '../packagedeals/packagedeals.scenarios.select.svelte.js';
import AppConfig from "../../AppConfig";
import * as money_util from "../../utils/MoneyUtil.js";
import DateTimeUtil from "../../utils/DateTimeUtil.js";

// NB dit truukje is dus blijkbaar nodig om ook gewoon de functies in deze file elkaar onderling te kunnen laten vinden
// als ze aangeroepen vanuit een andere file
import * as booking_select from "./booking.scenarios.select.svelte.js";
import {products} from "../products/feature.products.svelte.js";
import {progress} from "../progress/feature.progress.svelte.js";

export function getPreselection()
{
  const response = {
    sPreselectionType: false,
    sBuyableType: false,
    iID: false,
    sTitle: false,
    mBuyable: false
  };

  const {
          iUseThisEntryIDForFirstPerson,
          iPreselectedTreatmentSubcat,
          iPreselectedPackageDealID,
          iPreselectedTreatmentID,
          bIsAction,
          iPreselectedActionEntryProductID
        } = booking;

  if ( iUseThisEntryIDForFirstPerson )
  {
    response.sPreselectionType = PRESELECTION_TYPE_ENTRY;
    response.sBuyableType = BUYABLE_TYPE_NON_PACKAGEDEAL;
    response.iID = iUseThisEntryIDForFirstPerson;

    const product = products_select.getProductByID(iUseThisEntryIDForFirstPerson);
    if ( product )
    {
      response.sTitle = product.sTitle;
      response.mBuyable = product;
    }
  }
  else if ( bIsAction )
  {
    if ( iPreselectedPackageDealID )
    {
      response.sPreselectionType = PRESELECTION_TYPE_ACTION_PACKAGE_DEAL;
      response.sBuyableType = BUYABLE_TYPE_PACKAGEDEAL;
      response.iID = iPreselectedPackageDealID;
    }
    else
    {
      response.sPreselectionType = PRESELECTION_TYPE_ACTION_ENTRY;
      response.sBuyableType = BUYABLE_TYPE_NON_PACKAGEDEAL;
      response.iID = iUseThisEntryIDForFirstPerson;

      const product = products_select.getProductByID(iUseThisEntryIDForFirstPerson);

      if ( product )
      {
        response.sTitle = product.sTitle;
        response.mBuyable = product;
      }
    }
  }
  else if ( iPreselectedPackageDealID )
  {
    response.sPreselectionType = PRESELECTION_TYPE_PACKAGE_DEAL;
    response.sBuyableType = BUYABLE_TYPE_PACKAGEDEAL;
    response.iID = iPreselectedPackageDealID;

    const packageDeal = packagedeals_select.getPackageDealByID(iPreselectedPackageDealID);
    if ( packageDeal )
    {
      response.sTitle = packageDeal.sTitle;
      response.mBuyable = packageDeal;
    }
  }
  else if ( iPreselectedTreatmentSubcat )
  {
    response.sPreselectionType = PRESELECTION_TYPE_TREATMENT_SUBCAT;
    response.iID = iPreselectedTreatmentSubcat;
    response.sTitle = booking.sPreselectedTreatmentSubcatTitle;
  }
  else if ( iPreselectedTreatmentID )
  {
    response.sPreselectionType = PRESELECTION_TYPE_TREATMENT;
    response.sBuyableType = BUYABLE_TYPE_NON_PACKAGEDEAL;
    response.iID = iPreselectedTreatmentID;

    const product = products_select.getProductByID(iPreselectedTreatmentID);
    if ( product )
    {
      response.sTitle = product.sTitle;
      response.mBuyable = product;
    }
  }

  return response;
}

export function getCurrentlySelectedPackageDealIDOrPresetID()
{
  const person = booking_select.getPersonWithPackageDeal();

  if ( person && person.lBookedPackageDeals.length > 0 )
  {
    return person.lBookedPackageDeals[0].iID;
  }

  // Ok nog niemand heeft een arrangement, maar het kan ook nog zijn dat er een preselect is
  // meegegeven bij het laden van de pagina/config.. geef die id terug of false
  return booking.iPreselectedPackageDealID;
}

export function getPackageDealIDThatIsActuallyAddedToOrder()
{
  let oPersonWithPackageDeal = booking_select.getPersonWithPackageDeal();

  if ( oPersonWithPackageDeal !== null )
  {
    return oPersonWithPackageDeal.lBookedPackageDeals[0].iID;
  }

  return null;
}

export function isDinnerPartOfASelectedPackageDeal()
{
  let oPackageDeal = booking_select.getPackageDealIDThatIsActuallyAddedToOrder();

  if ( oPackageDeal !== null && oPackageDeal.bContainsDinner === true )
  {
    return true;
  }

  return false;
}

export function getPersonWithPackageDeal()
{
  return booking.lPeople.find((person) => person.lBookedPackageDeals.length > 0) || null;
}


export function getAllBookedProducts(bIncludeEntries = true, bIncludeInsurance = true, bIncludeBookedAsPartOfPackageDeal = true)
{
  const productIDs = [];

  for ( const oPerson of booking.lPeople )
  {
    for ( let i = 0; i < oPerson.lBookedBuyables.length; i++ )
    {
      const oBuyable = oPerson.lBookedBuyables[i];
      if (
        (bIncludeBookedAsPartOfPackageDeal !== true && oBuyable.iAddedAsPartOfPackageDealID !== false)
        || (!bIncludeEntries && products_select.isEntryProduct(oBuyable.iID))
        || (!bIncludeInsurance && products_select.isInsuranceProduct(oBuyable.iID))
      )
      {
        continue;
      }
      if ( !productIDs.includes(oBuyable.iID) )
      {
        productIDs.push(oBuyable.iID);
      }
    }
  }

  return productIDs;
}

export function getAllBookedProductCategories(bReturnStringsInsteadOfInts = false, bIncludePackageDealProducts = true)
{
  let aResponse = [];
  let aAllBookedProductIDs = booking_select.getAllBookedProducts(true, true, bIncludePackageDealProducts);

  let iProductCatID;
  aAllBookedProductIDs.forEach((iProductID) => {
    iProductCatID = products_select.getProductCatForLastProcessedDate(iProductID);

    if ( bReturnStringsInsteadOfInts === true )
    {
      iProductCatID = iProductCatID + "";
    }

    if ( aResponse.indexOf(iProductCatID) === -1 )
    {
      aResponse.push(iProductCatID + "");
    }
  });

  return aResponse;
}

export function getCurrentlySelectedActionEntry()
{
  let oResponse = false;
  const oPerson = booking_select.getPersonWithActionEntry();

  if ( oPerson )
  {
    const aBookedBuyables = oPerson.lBookedBuyables;
    for ( const oBookedBuyable of aBookedBuyables )
    {
      const iBuyableID = oBookedBuyable.iID;
      if ( products_select.isActionEntryProduct(iBuyableID) )
      {
        oResponse = iBuyableID;
      }
    }
  }

  return oResponse;
}

export function getCurrentlySelectedNonActionEntry()
{
  let oResponse = false;
  const oPerson = booking_select.getPersonWithNonActionEntry();

  if ( oPerson )
  {
    const aBookedBuyables = oPerson.lBookedBuyables;
    for ( let i = 0; i < aBookedBuyables.length; i++ )
    {
      const iBuyableID = aBookedBuyables[i].iID;
      if ( products_select.isNonActionEntryProduct(iBuyableID) )
      {
        oResponse = iBuyableID;
      }
    }
  }
// console.log("HIEEEEEEEER NON ACTION ENTRY ID", oResponse);
  return oResponse;
}

export function getPersonWithActionEntry()
{
  const aPeople = booking.lPeople;
  if ( !aPeople || aPeople.length === 0 ) return false;

  let oPersonWithActionEntry = false;

  for ( let i = 0; i < aPeople.length; i++ )
  {
    const oPerson = aPeople[i];
    const aBookedBuyables = oPerson.lBookedBuyables;
    for ( let j = 0; j < aBookedBuyables.length; j++ )
    {
      const oBookedBuyable = aBookedBuyables[j];
      const iBuyableID = oBookedBuyable.iID;
      if ( products_select.isActionEntryProduct(iBuyableID) )
      {
        oPersonWithActionEntry = oPerson;
      }
    }
  }

  return oPersonWithActionEntry;
}

export function getFirstPerson()
{
  const aPeople = booking.lPeople;
  return aPeople && aPeople.length > 0 ? aPeople[0] : false;
}

export function getPersonWithNonActionEntry()
{
  const aPeople = booking.lPeople;
  if ( !aPeople || aPeople.length === 0 ) return false;

  let oPersonWithNonActionEntry = false;

  for ( const oPerson of aPeople )
  {
    const aBookedBuyables = oPerson.lBookedBuyables;
    // console.log('cookiedough1', aBookedBuyables, $state.snapshot(aBookedBuyables));
    // console.log('cookiedough2', oPerson.lBookedBuyables);
    for ( const oBookedBuyable of aBookedBuyables )
    {
      const iBuyableID = oBookedBuyable.iID;
      if ( products_select.isNonActionEntryProduct(iBuyableID) )
      {
        oPersonWithNonActionEntry = oPerson;
      }
    }
  }

  return oPersonWithNonActionEntry;
}

export function getAllBookedProductIDsForPackageDealID(oPerson, iPackageDealID)
{
  const aBookedBuyables = oPerson.lBookedBuyables;
  const aProducts = [];

  for ( let i = 0; i < aBookedBuyables.length; i++ )
  {
    const oBuyable = aBookedBuyables[i];
    if ( oBuyable.iAddedAsPartOfPackageDealID === iPackageDealID )
    {
      aProducts.push(oBuyable.iID);
    }
  }

  return aProducts;
}

export function getAllBookedProductIDsForPackageDealIDWithTimeSlot(oPerson, iPackageDealID)
{
  const aBookedBuyables = oPerson.lBookedBuyables;
  const aProducts = [];

  for ( let i = 0; i < aBookedBuyables.length; i++ )
  {
    const oBuyable = aBookedBuyables[i];
    if ( oBuyable.iAddedAsPartOfPackageDealID === iPackageDealID )
    {
      aProducts.push({
        'iID': oBuyable.iID,
        'sTime': oBuyable.oTimeSlot.V
      });
    }
  }

  return aProducts;
}

export function getAllBookedProductsThatAreNotPartOfAnyPackageDeal(sOptionalPersonID = false, bIncludeEntries = true, bIncludeInsurance = false)
{
  const aProductIDs = [];
  const aPeople = sOptionalPersonID
    ? [booking.lPeople.find((oPerson) => oPerson.sID === sOptionalPersonID)]
    : booking.lPeople;

  if ( !aPeople || aPeople.length === 0 ) return aProductIDs;

  for ( let i = 0; i < aPeople.length; i++ )
  {
    const oPerson = aPeople[i];
    const aBookedBuyables = oPerson.lBookedBuyables;
    for ( let j = 0; j < aBookedBuyables.length; j++ )
    {
      const oBuyable = aBookedBuyables[j];
      const iBuyableID = oBuyable.iID;
      if ( !aProductIDs.includes(iBuyableID) && oBuyable.iAddedAsPartOfPackageDealID === false )
      {
        if ( bIncludeEntries || !products_select.isEntryProduct(iBuyableID) )
        {
          if ( bIncludeInsurance || !products_select.isInsuranceProduct(iBuyableID) )
          {
            aProductIDs.push(iBuyableID);
          }
        }
      }
    }
  }

  return aProductIDs;
}

export function getAllBookedProductsThatAreNotPartOfAnyPackageDealWithTimeSlots(sOptionalPersonID = false, bIncludeEntries = true, bIncludeInsurance = false)
{
  const aResponse = [];
  const aPeople = sOptionalPersonID
    ? [booking.lPeople.find((oPerson) => oPerson.sID === sOptionalPersonID)]
    : booking.lPeople;

  if ( !aPeople || aPeople.length === 0 ) return [];

  for ( let i = 0; i < aPeople.length; i++ )
  {
    const oPerson = aPeople[i];
    const aBookedBuyables = oPerson.lBookedBuyables;
    for ( let j = 0; j < aBookedBuyables.length; j++ )
    {
      const oBuyable = aBookedBuyables[j];
      const iBuyableID = oBuyable.iID;
      if ( !aResponse.includes(iBuyableID) && oBuyable.iAddedAsPartOfPackageDealID === false )
      {
        if ( bIncludeEntries || !products_select.isEntryProduct(iBuyableID) )
        {
          if ( bIncludeInsurance || !products_select.isInsuranceProduct(iBuyableID) )
          {
            aResponse.push({
              'iID': oBuyable.iID,
              'sTime': oBuyable.oTimeSlot.V
            });
          }
        }
      }
    }
  }

  return aResponse;
}

export function getProductPeopleCountPerTimeSlot(iBuyableID)
{
  // let oResponse = {};
  //
  // const oProduct = products_select.getProductByID(iBuyableID);
  //
  // if ( oProduct )
  // {
  //   let sTimeSlot;
  //
  //   // oResponse.P12 bevat een count van het aantal keer dat product 12 is geboekt
  //   // en daarbinnen heb je weer de tijdslots.. dus oResponse.P12.S900 = 2
  //   // in die S900 is 900 dan de value van het tijdslot (dus niet het label)
  //
  //   booking.lPeople.forEach((oPerson) => {
  //     oPerson.lBookedBuyables.forEach((oBookedProductConfig) => {
  //       sTimeSlot = oBookedProductConfig.sTimeSlot;
  //
  //       if ( typeof oResponse['P' + oPerson.sID] === "undefined" )
  //       {
  //         oResponse['P' + oPerson.sID] = {};
  //       }
  //
  //
  //     });
  //   });
  // }

  ///return oResponse;
}

export function isDayEntryWithIDEAL()
{
  return (
    booking.bShowListOfPackageDeals !== true &&
    booking.sPreferredPartOfTheDay === ENTRY_DURATION_DAY &&
    booker.sPaymentMethod === PAYMENT_TYPE_IDEAL
  );
}

export function getEntryBuyableIDForPartOfDayPreference(sPreferredPartOfDay)
{
  let iSelectedEntryID = AppConfig.iDefaultEntreeID; // standaard dag entree
  const isDayEntryWithIDEAL = booking_select.isDayEntryWithIDEAL();

  if ( sPreferredPartOfDay === ENTRY_DURATION_EVENING )
  {
    const aEveningEntryIDs = AppConfig.aEntreeAvondExternalIDs;
    if ( Array.isArray(aEveningEntryIDs) && aEveningEntryIDs.length > 0 )
    {
      iSelectedEntryID = aEveningEntryIDs[0];
    }
  }
  else if ( isDayEntryWithIDEAL && booking_select.doesIDealDiscountApply() )
  {
    //iSelectedEntryID = AppConfig.aEntreeDagIDEALKortingExternalID;
  }

  return iSelectedEntryID;
}

export function getNonStandardEntryBuyableIDForEntryType(sPreferredEntryType)
{
  // geef alleen iets terug als dit inderdaad niet de normale entrees zijn
  // op dit moment is badenkaart het enige afwijkende type


  let iSelectedEntryID = AppConfig.iDefaultEntreeID; // standaard dag entree
  const isDayEntryWithIDEAL = booking_select.isDayEntryWithIDEAL();

  if ( sPreferredPartOfDay === ENTRY_DURATION_EVENING )
  {
    const aEveningEntryIDs = AppConfig.aEntreeAvondExternalIDs;
    if ( Array.isArray(aEveningEntryIDs) && aEveningEntryIDs.length > 0 )
    {
      iSelectedEntryID = aEveningEntryIDs[0];
    }
  }
  else if ( isDayEntryWithIDEAL && booking_select.doesIDealDiscountApply() )
  {
    //iSelectedEntryID = AppConfig.aEntreeDagIDEALKortingExternalID;
  }

  return iSelectedEntryID;
}

export function doesIDealDiscountApply()
{
  // iDEAL korting tijdelijk uitzetten
  let bDoesDiscountApply = true; // De korting is altijd van toepassing, behalve op specifieke dagen

  const isDayEntry =
          booking.bShowListOfPackageDeals !== true &&
          booking.sPreferredPartOfTheDay === ENTRY_DURATION_DAY;

  if ( !isDayEntry )
  {
    return false;
  }

  const sArrivalDate = booking.sArrivalDate;
  if (
    Array.isArray(AppConfig.aDatesWithAlternativeTimes) &&
    AppConfig.aDatesWithAlternativeTimes.includes(sArrivalDate)
  )
  {
    bDoesDiscountApply = false;
  }

  return bDoesDiscountApply;
}

export function getAllBuyablesThatShouldHaveTheirPriceCheckedWhenDateChanges()
{
  const aResponse = [];
  const aPackageDealsToCheck = [];
  const aNonPackageDealBuyablesToCheck = [];

  const oAactionEntry = booking_select.getCurrentlySelectedActionEntry();
  if ( oAactionEntry ) aNonPackageDealBuyablesToCheck.push(oAactionEntry);

  const oNonActionEntry = booking_select.getCurrentlySelectedNonActionEntry();
  if ( oNonActionEntry ) aNonPackageDealBuyablesToCheck.push(oNonActionEntry);

  for ( const iBuyableID of aPackageDealsToCheck )
  {
    aResponse.push({
      sBuyableType: BUYABLE_TYPE_PACKAGEDEAL,
      iBuyableID: iBuyableID
    });
  }

  for ( const iBuyableID of aNonPackageDealBuyablesToCheck )
  {
    aResponse.push({
      sBuyableType: BUYABLE_TYPE_NON_PACKAGEDEAL,
      iBuyableID: iBuyableID
    });
  }

  return aResponse;
}

export function doesAnyPersonHaveProduct(iBuyableID)
{
  let bProductInOrder = false;

  booking.lPeople.forEach((oPerson) => {
    if ( bProductInOrder === false )
    {
      if ( booking_select.doesPersonHaveProduct(oPerson.sID, iBuyableID).bIsFound === true )
      {
        bProductInOrder = true;
      }
    }
  });

  return bProductInOrder;
}

export function doesPersonHaveProduct(sPersonID, iBuyableID)
{
  const aPeople = booking.lPeople;
  let oPerson = null;
  let bIsFound = false;
  let iAddedAsPartOfPackageDealID = null;
  let iChoiceIDInPackageDeal = null;

  if ( typeof sPersonID === "string" )
  {
    oPerson = aPeople.find((oCurrentPerson) => oCurrentPerson.sID === sPersonID);
  }
  else
  {
    oPerson = sPersonID;
  }

  if ( oPerson )
  {
    const aBookedBuyables = oPerson.lBookedBuyables || [];
    for ( let i = 0; i < aBookedBuyables.length; i++ )
    {
      const oBookedBuyable = aBookedBuyables[i];
      if ( oBookedBuyable.iID === iBuyableID )
      {
        bIsFound = true;
        iAddedAsPartOfPackageDealID = oBookedBuyable.iAddedAsPartOfPackageDealID || null;
        iChoiceIDInPackageDeal = oBookedBuyable.iChoiceIDInPackageDeal || null;
      }
    }
  }

  return {
    bIsFound,
    iAddedAsPartOfPackageDealID,
    iChoiceIDInPackageDeal
  };
}

export function bDoesAnyoneHaveBookedNonPackageDealBuyables(bIgnoreEntries = false, bIgnoreInsurance = true)
{
  const aPeople = booking.lPeople;
  const bIncludeEntries = !bIgnoreEntries;
  const bIncludeInsurance = !bIgnoreInsurance;

  if ( aPeople )
  {
    for ( let i = 0; i < aPeople.length; i++ )
    {
      const mPerson = aPeople[i];
      const aNonPackageDealBuyablesForPerson = booking_select.getAllBookedProductsThatAreNotPartOfAnyPackageDeal(
        mPerson.sID,
        bIncludeEntries,
        bIncludeInsurance
      );

      if ( aNonPackageDealBuyablesForPerson.length > 0 )
      {
        return true;
      }
    }
  }

  return false;
}

export function getCurrentInsuranceProductIDBookedForPerson(sPersonID)
{
  const lPeople = booking.lPeople;
  let oPerson = typeof sPersonID === 'string' ? lPeople.find((oPerson) => oPerson.sID === sPersonID) : sPersonID;
  let oResponse = false;

  if ( oPerson )
  {
    const aBookedBuyables = oPerson.lBookedBuyables || [];
    for ( let i = 0; i < aBookedBuyables.length; i++ )
    {
      const oBookedBuyable = aBookedBuyables[i];
      if ( products_select.isInsuranceProduct(oBookedBuyable.iID) )
      {
        oResponse = oBookedBuyable.iID;
      }
    }
  }

  return oResponse;
}

export function getPackageDealChoicesStatusReport()
{
  const oReport = {
    aPeople: []
  };

  const iSelectedPackageDealID = booking_select.getPackageDealIDThatIsActuallyAddedToOrder();
  //console.log('iSelectedPackageDealID:', iSelectedPackageDealID);
  const oSelectedPackageDeal = iSelectedPackageDealID
    ? packagedeals_select.getPackageDealByID(iSelectedPackageDealID)
    : false;

  const aProductGroupsThatAreOptionInPackageDeal = packagedeals_select.getProductGroupsThatAreOptionInPackageDeal(iSelectedPackageDealID);
  //console.log('Validatiecheck 2B - aProductGroupsThatAreOptionInPackageDeal', iSelectedPackageDealID, $state.snapshot(aProductGroupsThatAreOptionInPackageDeal));
  oReport.aProductGroupsThatAreOptionInPackageDeal = aProductGroupsThatAreOptionInPackageDeal;

  if ( oSelectedPackageDeal )
  {
    const aPeople = booking.lPeople;

    for ( let i = 0; i < aPeople.length; i++ )
    {
      const oPerson = aPeople[i];
      const aReportPerPerson = {};
      for ( let j = 0; j < aProductGroupsThatAreOptionInPackageDeal.length; j++ )
      {
        const oChoiceSet = aProductGroupsThatAreOptionInPackageDeal[j];
        const oCurrentChoiceInGroup = booking_select.getCurrentChoiceForPersonForPackageDealGroup(
          oPerson.sID,
          iSelectedPackageDealID,
          oChoiceSet.iChoiceID
        );

        aReportPerPerson[`c${oChoiceSet.iChoiceID}`] = oCurrentChoiceInGroup;
      }

      oReport.aPeople[oPerson.sID] = aReportPerPerson;
    }
  }

  oReport.iSelectedPackageDealID = iSelectedPackageDealID;
  return oReport;
}

export function getCurrentChoiceForPersonForPackageDealGroup(sPersonID, iPackageDealID, iChoiceGroupID)
{
  const lPeople = booking.lPeople;
  let oPerson = typeof sPersonID === 'string' ? lPeople.find((p) => p.sID === sPersonID) : sPersonID;
  let oResponse = false;
  let bDoesPersonHavePackageDeal = false;

  if ( oPerson )
  {
    const aBookedPackageDeals = oPerson.lBookedPackageDeals || [];

    for ( let i = 0; i < aBookedPackageDeals.length; i++ )
    {
      const mBookedPackageDeal = aBookedPackageDeals[i];

      if ( mBookedPackageDeal.iID === iPackageDealID )
      {
        bDoesPersonHavePackageDeal = true;
      }
    }

    if ( bDoesPersonHavePackageDeal )
    {
      const aBookedBuyables = oPerson.lBookedBuyables || [];

      for ( let i = 0; i < aBookedBuyables.length; i++ )
      {
        const oBookedBuyable = aBookedBuyables[i];
        if ( oBookedBuyable.iChoiceIDInPackageDeal === iChoiceGroupID )
        {
          oResponse = oBookedBuyable.iID;
        }
      }
    }
  }

  return oResponse;
}

export function doCurrentBookingAndBookerValuesSuggestASpecialEntryProduct()
{
  // geef false of de id van het entree product terug

  // Check of we maar 2 uur komen en dus een korte entree kunnen gebruiken
  // Als we een normale badenkaartboeking aan het doen zijn dan niet ongevraagd switchen
  if ( booking.iArrivalTime && booking.iDepartureTime && booking.sSelectedEntryType !== ENTRY_TYPE_OVERRULE_BADENKAART )
  {
    // 2 UURS ENTREE
    // als je niet langer dan 120 minuten blijft (overdag of in de avond want 2 uurs is het goedkoopste)
    let aTemp = DateTimeUtil.getTimeObjectsFromTo(booking.iArrivalTime, booking.iDepartureTime, 15);

    if ( aTemp && aTemp.length <= 9 )
    {
      // 2 uur of minder

      // Zijn we een badenkaart kort entree aan het boeken? Dat zou voor wat betreft de tijd iig mogen.
      if ( booking.sSelectedEntryType === ENTRY_TYPE_OVERRULE_BADENKAART_KORT )
      {
        return AppConfig.iEntree2uurBadenkaartExternalID;
      }

      return AppConfig.iEntree2uurExternalID;
    }
  }

  // badenkaart dag?
  if ( booking.sSelectedEntryType === ENTRY_TYPE_OVERRULE_BADENKAART )
  {
    return AppConfig.iDefaultEntreeBadenkaartID;
  }

  return false;
}

export function getBuyableToAddForNewPeople()
{
  let bDebug = false;
  // let bDebug = true;
  if ( bDebug ) console.log('getBuyableToAddForNewPeople A');

  // er kunnen een aantal situaties zijn
  // A) er zijn nog geen andere personen, het is geen actie: in dat geval kijken we eerst naar iUseThisEntryIDForFirstPerson en als daar niets is ingesteld naar sPreferredPartOfTheDay voor een type entree dat we toevoegen
  // B) er zijn nog geen andere personen, het is een actie - actie entree toevoegen
  // C) er zijn al andere personen en die hebben een arrangement - dan voegen we die hier ook toe
  // D) er zijn al andere personen en die hebben een niet-actie entree, dan voegen we die hier ook toe
  // E) er zijn al andere personen en die hebben geen arrangement en geen non-actie entree.. dan doen we nietssss
  // F) er zijn al andere personen en die hebben een actie entree - voeg dan een normale entree toe aan de nieuwe persoon
  // voor 1 persoons acties waaraan jsonHmkResSessionExtraEntree mee is gegeven staat vast welke default entree iedereen behalve de 1e persoon krijgt
  let sBuyableType = BUYABLE_TYPE_PACKAGEDEAL;
  let iBuyableID = AppConfig.iDefaultEntreeID;

  const lPeople = booking.lPeople;
  const sPreferredPartOfTheDay = booking.sPreferredPartOfTheDay;

  if ( lPeople.length > 1 )
  {
    if ( bDebug ) console.log('getBuyableToAddForNewPeople > 1');
    const iPackageDeal = booking_select.getCurrentlySelectedPackageDealIDOrPresetID();

    if ( iPackageDeal )
    {
      if ( bDebug ) console.log('getBuyableToAddForNewPeople > 1 B');
      iBuyableID = iPackageDeal;

      return {
        sBuyableType,
        iBuyableID
      };
    }
    else
    {// GEEN arrangement
      if ( bDebug ) console.log('getBuyableToAddForNewPeople > 1 C');
      sBuyableType = BUYABLE_TYPE_NON_PACKAGEDEAL;
      const iActionEntry = booking_select.getCurrentlySelectedActionEntry();
      const iNonActionEntry = booking_select.getCurrentlySelectedNonActionEntry();
      const aEntreesDieNaastActieEntreeBoekbaarZijn = booking.aExtraBoekbareEntreesNaastActie;

      //console.log('addPerson ad hoc 1', iActionEntry);
      if ( iActionEntry )
      {// F) er zijn al andere personen en die hebben een actie entree - voeg dan een normale entree toe aan de nieuwe persoon,
        if ( bDebug ) console.log('getBuyableToAddForNewPeople > 1 D');

        // als er al iemand met en niet-actie entree is, neem die dan over
        if ( iNonActionEntry )
        {// D) er zijn al andere personen en die hebben een niet-actie entree, dan voegen we die hier ook toe
          if ( bDebug ) console.log('getBuyableToAddForNewPeople > 1 E');
          iBuyableID = iNonActionEntry;
        }
        else if ( aEntreesDieNaastActieEntreeBoekbaarZijn.length > 0 )
        {
          if ( bDebug ) console.log('getBuyableToAddForNewPeople > 1 F');
          iBuyableID = aEntreesDieNaastActieEntreeBoekbaarZijn[0];
        }
        else
        {// terugvallen op normale entree
          if ( bDebug ) console.log('getBuyableToAddForNewPeople > 1 G');

          iBuyableID = booking_select.getEntryBuyableIDForPartOfDayPreference(sPreferredPartOfTheDay);

          // maken de tijden dat we een korte entree kunnen gebruiken?
          let iSpecialMainEntryIDToUse = booking_select.doCurrentBookingAndBookerValuesSuggestASpecialEntryProduct();

          if ( iSpecialMainEntryIDToUse )
          {
            iBuyableID = iSpecialMainEntryIDToUse;
          }
        }

        if ( bDebug ) console.log('getBuyableToAddForNewPeople > 1 Z1', sBuyableType, iBuyableID);

        return {
          sBuyableType,
          iBuyableID
        };
      }
      else if ( iNonActionEntry )
      {// er zijn al mensen en die hebben een non atie entry
        iBuyableID = iNonActionEntry;
        //iBuyableID = booking_select.getEntryBuyableIDForPartOfDayPreference(sPreferredPartOfTheDay);

        if ( bDebug ) console.log('getBuyableToAddForNewPeople > 1 Z2', sBuyableType, iBuyableID);

        return {
          sBuyableType,
          iBuyableID
        };
      }
    }
  }

  // als er nog geen personen zijn of er is net een arrangement verwijderd dan behandelen we dit als de opstartfase
  // dit blok gaat dus alleen over entrees TENZIJ er een preset arrangement is meegegeven
  if ( bDebug ) console.log('getBuyableToAddForNewPeople === 1 B');
  const iPackageDeal = booking_select.getCurrentlySelectedPackageDealIDOrPresetID();

  if ( iPackageDeal )
  {
    if ( bDebug ) console.log('getBuyableToAddForNewPeople === 1 C', sBuyableType, iPackageDeal);

    iBuyableID = iPackageDeal;

    return {
      sBuyableType,
      iBuyableID
    };
  }

  // Ok entrees
  // er zou geen onderscheid moeten zijn tussen actie en geen actie.. het product staat gewoon in iUseThisEntryIDForFirstPerson
  // if ( mState.getIn(['booking', 'bIsAction']) === true )
  // {   // B) er zijn nog geen andere personen, het is een actie - actie entree toevoegen
  //     iBuyableID = mState.getIn(['booking', 'iActionID']);
  //
  //     // iActionID kan bij een arrangement of een product horen
  //     // alleen als het om een product (entree) gaat moeten we er hier iets mee

  //     sBuyableType = BUYABLE_TYPE_NON_PACKAGEDEAL;
  // }
  // else
  // {
  // A) er zijn nog geen andere personen, het is geen actie: in dat geval kijken we eerst naar iUseThisEntryIDForFirstPerson en als daar niets is ingesteld naar sPreferredPartOfTheDay voor een type entree dat we toevoegen

  const iUseThisEntryIDForFirstPerson = booking.iUseThisEntryIDForFirstPerson;
  const iPreselectedPackageDealID = booking.iPreselectedPackageDealID;

  if ( iUseThisEntryIDForFirstPerson )
  {
    if ( bDebug ) console.log('getBuyableToAddForNewPeople === 1 C');
    iBuyableID = iUseThisEntryIDForFirstPerson;
  }
  else
  {
    if ( bDebug ) console.log('getBuyableToAddForNewPeople === 1 D1');

    // als er wel een preset voor een arrangement is meegegeven, dan voegen we niets toe zodat het bedrag 0 blijft en iemand verderop het arrangement kan kiezen
    if ( iPreselectedPackageDealID )
    {
      if ( bDebug ) console.log('getBuyableToAddForNewPeople === 1 D2');
      // doe niets
      sBuyableType = false;
      iBuyableID = false;
    }
    else
    {
      // maken de tijden dat we een korte entree kunnen gebruiken?
      let iSpecialMainEntryIDToUse = booking_select.doCurrentBookingAndBookerValuesSuggestASpecialEntryProduct();

      if ( bDebug ) console.log('getBuyableToAddForNewPeople === 1 D3', iSpecialMainEntryIDToUse);

      if ( iSpecialMainEntryIDToUse )
      {
        iBuyableID = iSpecialMainEntryIDToUse;
      }
      else
      {
        iBuyableID = booking_select.getEntryBuyableIDForPartOfDayPreference(sPreferredPartOfTheDay);
      }

      sBuyableType = BUYABLE_TYPE_NON_PACKAGEDEAL;
    }
  }


  // console.log('addPerson ad hoc getBuyableToAdd', {
  //   sBuyableType,
  //   iBuyableID
  // });

  if ( bDebug ) console.log('getBuyableToAddForNewPeople === 1 ZZ', sBuyableType, iBuyableID);

  return {
    sBuyableType,
    iBuyableID
  };
}

export function areThereAnyNonEntryProductsInBooking(bIncludeInsurance = false)
{
  const aPeople = booking.lPeople;
  if ( !aPeople ) return false;

  for ( let i = 0; i < aPeople.length; i++ )
  {
    const oPerson = aPeople[i];
    const aBookedBuyables = oPerson.lBookedBuyables || [];
    for ( let j = 0; j < aBookedBuyables.length; j++ )
    {
      const oBookedBuyable = aBookedBuyables[j];
      const iBuyableID = oBookedBuyable.iID;

      if ( !products_select.isEntryProduct(iBuyableID) )
      {
        if ( bIncludeInsurance || !products_select.isInsuranceProduct(iBuyableID) )
        {
          return true;
        }
      }
    }
  }

  return false;
}

export function areThereAnyTreatmentProductsInBooking()
{
  const aPeople = booking.lPeople;
  if ( !aPeople ) return false;

  for ( let i = 0; i < aPeople.length; i++ )
  {
    const oPerson = aPeople[i];
    const aBookedBuyables = oPerson.lBookedBuyables || [];
    for ( let j = 0; j < aBookedBuyables.length; j++ )
    {
      const oBookedBuyable = aBookedBuyables[j];
      const iBuyableID = oBookedBuyable.iID;

      if ( products_select.isTreatmentProduct(iBuyableID) )
      {
        return true;
      }
    }
  }

  return false;
}

export function getAppropriateInsuranceProductID()
{
  // zie ook isInsuranceProduct
  const iSubTotalFormCents = booking.mTotals.mSubTotalTreatments.iCents;

  const bIsEntreeOnly = (
    !booking_select.isPackageDealBooking() &&
    !booking_select.areThereAnyNonEntryProductsInBooking() &&
    booking.bShowListOfPackageDeals !== true
  );

  let iInsuranceBuyableID = false;

  if ( bIsEntreeOnly )
  {
    iInsuranceBuyableID = 61;
  }
  else if ( iSubTotalFormCents >= 0 && iSubTotalFormCents < 5000 )
  {
    iInsuranceBuyableID = 62;
  }
  else if ( iSubTotalFormCents >= 5000 && iSubTotalFormCents < 10000 )
  {
    iInsuranceBuyableID = 63;
  }
  else if ( iSubTotalFormCents >= 10000 && iSubTotalFormCents < 15000 )
  {
    iInsuranceBuyableID = 64;
  }
  else if ( iSubTotalFormCents >= 15000 && iSubTotalFormCents < 20000 )
  {
    iInsuranceBuyableID = 65;
  }
  else if ( iSubTotalFormCents >= 20000 && iSubTotalFormCents < 25000 )
  {
    iInsuranceBuyableID = 66;
  }
  else if ( iSubTotalFormCents >= 25000 && iSubTotalFormCents < 30000 )
  {
    iInsuranceBuyableID = 67;
  }
  else if ( iSubTotalFormCents >= 30000 && iSubTotalFormCents < 35000 )
  {
    iInsuranceBuyableID = 68;
  }
  else if ( iSubTotalFormCents >= 35000 )
  {
    iInsuranceBuyableID = 69;
  }

  return iInsuranceBuyableID;
}

export function isPriceZero()
{
  const lValidGiftcardCodes = booking.lValidGiftcardCodes;
  const iTotal = booking.mTotals.mTotal.iCents;

  if ( parseFloat(iTotal) < 0.01 )
  {
    return true;
  }

  // if ( lValidGiftcardCodes && lValidGiftcardCodes.length > 0 )
  // {
  //   if ( parseFloat(iTotal) < 0.01 )
  //   {
  //     return true;
  //   }
  // }

  // const lValidBadenkaartCodes = booking.lValidBadenkaartCodes;
  //
  // if ( lValidBadenkaartCodes && lValidBadenkaartCodes.length > 0 )
  // {
  //   return true;
  // }

  return false;
}

export function hasAnyoneChosenTreatments()
{
  let iLargestNrForOnePerson = 0;

  for ( const oPerson of booking.lPeople )
  {
    let aAllBookedProducts = booking_select.getAllBookedProducts(false, false, false);

    const iIndex = aAllBookedProducts.indexOf(932);
    if ( iIndex !== -1 )
    {
      aAllBookedProducts.splice(iIndex, 1);
    }

    if ( aAllBookedProducts.length > iLargestNrForOnePerson )
    {
      iLargestNrForOnePerson = aAllBookedProducts.length;
    }
  }

  return iLargestNrForOnePerson > 0;
}

export function isPackageDealBooking()
{
  return booking.bShowListOfPackageDeals === true;
}

// export function getProductsAddedAsDefaultPartOfPackageDeal()
// {
//   if ( !this.props.mSelectedPackageDeal ) return false;
//
//   const lProducts = this.props.mSelectedPackageDeal.get('lProducts');
//   if ( !lProducts ) return false;
//
//   const aProducts = [];
//   lProducts.forEach((mProduct) => {
//     if ( mProduct.get('iChoiceID') === false )
//     {
//       aProducts.push(mProduct);
//     }
//   });
//
//   return aProducts;
// }

export function updateBookingSummary()
{
  // let bDebugSummary = true;
  let bDebugSummary = false;
  if ( bDebugSummary === true ) console.log('-------');
  if ( bDebugSummary === true ) console.log('start getBookingSummary');
  const sArrivalDate = booking.sArrivalDate;

  if ( !sArrivalDate )
  {
    // dit lijkt lokaal op de dev server bij HMD nog wel eens te gebeuren
    if ( progress.iCurrentVisibleStep > 20 )
    {
      // alert('geen datum gekozen');
      console.log('geen datum gekozen');
    }
    return;
  }

  //const sDepartureDate = booking.sDepartureDate;
  let aDays, oPriceOfPackageDealCorrectedForBookedRoom;

  booking.oBookingSummary.aPeople = [];
  booking.oBookingSummary.bShowCombinedReceipt = true; // is tegenwoordig een combinatie van bDoAllPeopleHaveSameBooking en bIsThereATimeSelected
  booking.oBookingSummary.bDoAllPeopleHaveSameBooking = true;
  booking.oBookingSummary.bIsThereATimeSelected = false;
  //booking.oBookingSummary.bShowReceipt = false;
  //booking.oBookingSummary.oProductPeopleCount = {};

  let aProductHashesPerPerson = [];

  const lPeople = booking.lPeople;
  let aDebug = [];

  lPeople.forEach((oPerson) => {
    const oPersonConfig = {};
    oPersonConfig.sID = oPerson.sID;

    if ( bDebugSummary === true ) console.log('getBookingSummary start persoon', oPersonConfig.sID);

    oPersonConfig.sName = oPerson.sName;
    oPersonConfig.aBookedPackageDeals = [];
    oPersonConfig.aBookedProductsWithoutPackageDeal = [];
    oPersonConfig.aBookedProductIDsWithoutPackageDeal = [];
    oPersonConfig.aAllBookedProductIDs = [];
    oPersonConfig.oAllBookedProductTimes = {};
    oPersonConfig.aAllBookedProductIDsForComparison = [];

    // PRODUCTEN ZONDER ARRANGEMENT
    const aBookedProductConfigsWithoutPackageDeal = booking_select.getAllBookedProductsThatAreNotPartOfAnyPackageDealWithTimeSlots(oPerson.sID);
    const aBookedProductIDsWithoutPackageDeal = [];

    aBookedProductConfigsWithoutPackageDeal.forEach((oBookedProductConfig) => {
      aBookedProductIDsWithoutPackageDeal.push(oBookedProductConfig.iID);

      //booking_select.updateBookingSummaryProductPeopleCountAdd(oBookedProductConfig);
    });

    if ( bDebugSummary === true ) console.log('getBookingSummary aBookedProductIDsWithoutPackageDeal', aBookedProductIDsWithoutPackageDeal);
    oPersonConfig.aAllBookedProductIDs = oPersonConfig.aAllBookedProductIDs.concat(aBookedProductIDsWithoutPackageDeal);

    let aProductIDsToHide = [];
    //let aProductIDsToHide = [AppConfig.iIDOfParkingTicket]; // parkeerkaart niet tonen

    for ( let j = 0; j < oPersonConfig.aAllBookedProductIDs.length; ++j )
    {
      // als dit product niet in de lijst staat om te negeren dan tonen we die
      let bHideFromSummary = false;
      if ( aProductIDsToHide.indexOf(oPersonConfig.aAllBookedProductIDs[j]) !== -1 )
      {
        bHideFromSummary = true;
      }
      else
      {
        oPersonConfig.aAllBookedProductIDsForComparison.push(oPersonConfig.aAllBookedProductIDs[j]);
      }

      let oProduct = products_select.getProductByID(oPersonConfig.aAllBookedProductIDs[j]);

      //let bIsProductBookedAsKoppelVerkoop = booking_select.isProductBookedAsKoppelVerkoop(oPersonConfig.sID, oProduct.iID);

      if ( bDebugSummary === true ) console.log('response bIsProductBookedAsKoppelVerkoop voor product ' + oProduct.iID + ' en persoon ' + oPersonConfig.sID, bIsProductBookedAsKoppelVerkoop);

      oPersonConfig.aBookedProductsWithoutPackageDeal.push({
        iID: oProduct.iID,
        //bIsProductBookedAsKoppelVerkoop: bIsProductBookedAsKoppelVerkoop,
        oProduct: oProduct,
        bHideFromSummary: bHideFromSummary
      });

      oPersonConfig.aBookedProductIDsWithoutPackageDeal.push(oProduct.iID);
    }

    // ARRANGEMENT(EN) EN DE PRODUCTEN DAARIN
    const lBookedPackageDeals = oPerson.lBookedPackageDeals;

    if ( lBookedPackageDeals )
    {
      lBookedPackageDeals.forEach((oBookedPackageDeal) => {
        const iPackageDealID = oBookedPackageDeal.iID;
        const oPackageDealBaseConfig = packagedeals_select.getPackageDealByID(iPackageDealID);
        if ( bDebugSummary === true ) console.log('getBookingSummary er is een arrangement geboekt:', iPackageDealID);
        const aAllBookedProductConfigsInPackageDeal = booking_select.getAllBookedProductIDsForPackageDealIDWithTimeSlot(oPerson, iPackageDealID);
        const aAllBookedProductIDsInPackageDeal = [];

        aAllBookedProductConfigsInPackageDeal.forEach((oBookedProductConfig) => {
          aAllBookedProductIDsInPackageDeal.push(oBookedProductConfig.iID);

          //booking_select.updateBookingSummaryProductPeopleCountAdd(oBookedProductConfig);
        });

        if ( bDebugSummary === true ) console.log('getBookingSummary aAllBookedProductIDsInPackageDeal:', aAllBookedProductIDsInPackageDeal);

        //aDays = DateTimeUtil.getDaysFromRange(sArrivalDate, sDepartureDate);
        aDays = DateTimeUtil.getDaysFromRange(sArrivalDate, sArrivalDate);
        //let aDaysInPeriodWherePackageDealShouldBeBooked = PackageDealsUtil.getDaysWhenPackageDealShouldBeBookedForRange(oPackageDealBaseConfig, iPackageDealID, aDays);
        if ( bDebugSummary === true ) console.log('getBookingSummary mPackageDealBaseConfig', oPackageDealBaseConfig);

        //if ( bDebugSummary === true ) console.log('getBookingSummary iMaxDays van arrangement:', iMaxDays, 'totaal aantal dagen is:', aDays, 'dus dagen waarop arrangementen moeten beginnen:', aDaysInPeriodWherePackageDealShouldBeBooked);

        const aAllBookedProductIDsInPackageDealWithoutRooms = booking_select.getAllBookedProductIDsForPackageDealID(oPerson, iPackageDealID);

        oPersonConfig.aAllBookedProductIDsWithoutRooms = oPersonConfig.aAllBookedProductIDs.concat(aAllBookedProductIDsInPackageDealWithoutRooms);

        oPersonConfig.aAllBookedProductIDs = oPersonConfig.aAllBookedProductIDs.concat(aAllBookedProductIDsInPackageDeal);

        const aAllBookedProductsInPackageDeal = [];
        for ( let i = 0; i < aAllBookedProductIDsInPackageDeal.length; ++i )
        {
          oPersonConfig.aAllBookedProductIDsForComparison.push(aAllBookedProductIDsInPackageDeal[i]);
          aAllBookedProductsInPackageDeal.push({
            oProduct: products_select.getProductByID(aAllBookedProductIDsInPackageDeal[i]),
            oProductInPackageDeal: packagedeals_select.getProductInPackageDeal(oBookedPackageDeal.iID, aAllBookedProductIDsInPackageDeal[i]) // met oa iAdditionalCosts
          });
        }

        let oPackageDeal = packagedeals_select.getPackageDealByID(iPackageDealID);
        let iPriceOfPackageDealCorrectedForBookedRoomAndDays = 0;
        let mPackageDealInfoForLastProcessedDate = packagedeals_select.getPackageDealInfoForLastProcessedDate(oBookedPackageDeal.iID);
        //console.log("HIERRRR mPackageDealInfoForLastProcessedDate", $state.snapshot(mPackageDealInfoForLastProcessedDate), mPackageDealInfoForLastProcessedDate);
        iPriceOfPackageDealCorrectedForBookedRoomAndDays = mPackageDealInfoForLastProcessedDate.iPrice;

        if ( bDebugSummary === true ) console.log("getBookingSummary iPriceOfPackageDealCorrectedForBookedRoomAndDays", iPriceOfPackageDealCorrectedForBookedRoomAndDays);
        oPriceOfPackageDealCorrectedForBookedRoom = money_util.centsToFriendly(iPriceOfPackageDealCorrectedForBookedRoomAndDays);

        let aBookedPackageDealConfig = {
          iID: oBookedPackageDeal.iID,
          oPackageDeal: oPackageDeal,
          aAllDaysInPeriod: aDays,
          //aDaysInPeriodWherePackageDealShouldBeBooked: aDaysInPeriodWherePackageDealShouldBeBooked,
          iPriceOfPackageDealCorrectedForBookedRoomAndDays: iPriceOfPackageDealCorrectedForBookedRoomAndDays,
          sPriceOfPackageDealCorrectedForBookedRoomAndDays: oPriceOfPackageDealCorrectedForBookedRoom.sEuros + ',' + oPriceOfPackageDealCorrectedForBookedRoom.sCents,
          aBookedProductsInPackageDeal: aAllBookedProductsInPackageDeal,
          mPackageDealInfoForLastProcessedDate: mPackageDealInfoForLastProcessedDate
        };

        aDebug.push(['Config voor 1 persoon voor het arrangement:', aBookedPackageDealConfig]);
        oPersonConfig.aBookedPackageDeals.push(aBookedPackageDealConfig);
      }); // eof lBookedPackageDeals.forEach((mBookedPackageDeal) => {
    }

    // voor bDoAllPeopleHaveSameBooking
    aProductHashesPerPerson.push(oPersonConfig.aAllBookedProductIDsForComparison.join('-'));

    // oAllBookedProductTimes
    oPersonConfig.aAllBookedProductIDs.forEach((iBookedProductID) => {
      let sSelectedTimeslot = booking_select.getSelectedTimeSlotForProduct(oPersonConfig.sID, iBookedProductID, true);

      if ( sSelectedTimeslot !== false && sSelectedTimeslot !== "" && sSelectedTimeslot !== "x" && sSelectedTimeslot !== "y" )
      {
        oPersonConfig.oAllBookedProductTimes['p' + iBookedProductID] = sSelectedTimeslot;

        if ( booking.oBookingSummary.bIsThereATimeSelected === false )
        {
          //console.log('er is een tijd gekozen:', sSelectedTimeslot, oPersonConfig.sID, iBookedProductID);
          booking.oBookingSummary.bIsThereATimeSelected = true;
        }
      }
    });

    booking.oBookingSummary.aPeople.push(oPersonConfig);
  }); // eof lPeople.forEach((oPerson) => {

  booking.oBookingSummary.iNrOfPeople = booking.oBookingSummary.aPeople.length;

  //console.log('svs debug', aDebug);

  // bDoAllPeopleHaveSameBooking
  let sPrevProductHash = false;
  for ( let i = 0; i < aProductHashesPerPerson.length; ++i )
  {
    if ( i > 0 && sPrevProductHash !== aProductHashesPerPerson[i] ) booking.oBookingSummary.bDoAllPeopleHaveSameBooking = false;
    sPrevProductHash = aProductHashesPerPerson[i];
  }

  // Parkeerkosten
  //booking.oBookingSummary.iTotalParkingCostsCents = booking_select.getTotalParkingCostsCents();

  booking.oBookingSummary.iLastUpdateTime = Date.now();

  // lijst met per product het aantal gebruikte slots en nog beschikbaar
  // loop door alle producten en maak een config voor de producten die dat hierboven nog niet gekregen hebben
  products.lItems.forEach((oProduct) => {
    // vraag de product extra data op om bij de tijdslots te komen en voeg die hier toe
    const oAvailableTreatment = products_select.getProductInfoFromAvailableTreatmentsByID(oProduct.iID);
    if ( oAvailableTreatment === false ) return;
  });

  if ( booking.oBookingSummary.bDoAllPeopleHaveSameBooking === true && booking.oBookingSummary.bIsThereATimeSelected === false )
  {
    booking.oBookingSummary.bShowCombinedReceipt = true;
  }
  else
  {
    booking.oBookingSummary.bShowCombinedReceipt = false;

    if ( booking.lPeople.length > 1 )
    {
      // het idee is dat als we de bon eenmaal vergroten dat we hem groot laten en niet heen en weer gaan ping pongen als je weer dingen uit je order haalt
      progress.bWasReceiptLarge = true;
    }
  }

  return booking.oBookingSummary;
}


export function getSelectedTimeSlotForProduct(sPersonID, iProductID, bReturnJustTheTimeAsString = false)
{
  const aPeople = sPersonID
    ? [booking.lPeople.find((oPerson) => oPerson.sID === sPersonID)]
    : booking.lPeople;

  if ( !aPeople || aPeople.length === 0 ) return [];

  for ( let i = 0; i < aPeople.length; i++ )
  {
    const oPerson = aPeople[i];
    const aBookedBuyables = oPerson.lBookedBuyables;

    for ( let j = 0; j < aBookedBuyables.length; j++ )
    {
      const oBuyable = aBookedBuyables[j];
      const iProductIDInBooking = oBuyable.iID;

      if ( parseInt(iProductIDInBooking) === parseInt(iProductID) )
      {
        if ( bReturnJustTheTimeAsString === true )
        {
          let oTimeSlot = oBuyable.oTimeSlot;
          return booking_select.transformTimeSlotLabelToTimeString(oTimeSlot.L);
        }

        return oBuyable.oTimeSlot;
      }
    }
  }

  if ( bReturnJustTheTimeAsString === true )
  {
    return "";
  }

  return false;
}

export function transformTimeSlotLabelToTimeString(sInput)
{
  if ( !sInput || typeof sInput !== "string" )
  {
    return "";
  }

  // Op dit moment is de opbouw van het label: "Om 11:00"
  // dus moeten we "Om " er af halen

  // window.console.log('transformTimeSlotLabelToTimeString', sInput, sInput.replace("Om ", ""));
  return sInput.replace("Om ", "");
}


export function updateBookingSummaryProductPeopleCountAdd(oBookedProductConfig)
{
  // const iProductID = oBookedProductConfig.iID;
  // const sBookedTimeSlot = oBookedProductConfig.sTime;
  //
  // if ( typeof booking.oBookingSummary.oProductPeopleCount["P" + iProductID] === "undefined" )
  // {
  //   booking.oBookingSummary.oProductPeopleCount["P" + iProductID] = {
  //     iNrOfPeople: 0,
  //     aTimeSlotsUsed: {},
  //     aTimeSlots: [] // vullen we niet hier
  //   };
  // }
  //
  // booking.oBookingSummary.oProductPeopleCount["P" + iProductID].iNrOfPeople += 1;
  //
  // if ( typeof booking.oBookingSummary.oProductPeopleCount["P" + iProductID].aTimeSlotsUsed[sBookedTimeSlot] === "undefined" )
  // {
  //   booking.oBookingSummary.oProductPeopleCount["P" + iProductID].aTimeSlotsUsed[sBookedTimeSlot] = 0;
  // }
  //
  // booking.oBookingSummary.oProductPeopleCount["P" + iProductID].aTimeSlotsUsed[sBookedTimeSlot] += 1;
  // console.log('wawa 1:', sBookedTimeSlot, $state.snapshot(booking.oBookingSummary.oProductPeopleCount["P" + iProductID].aTimeSlotsUsed[sBookedTimeSlot]));
}